/**
 * LP Scroll Reveal
 * Drives .lp-reveal entrance animations for standalone LP sections.
 * Safe to include from multiple sections on the same page — the observer
 * is created once and reused; elements are never double-observed.
 */
(function () {
  'use strict';

  if (!window.IntersectionObserver) {
    // Graceful degradation: just make everything visible
    document.querySelectorAll('.lp-reveal').forEach(function (el) {
      el.classList.add('on');
    });
    return;
  }

  if (!window.__lpReveal) {
    window.__lpReveal = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('on');
          window.__lpReveal.unobserve(e.target);
        }
      });
    }, { threshold: 0.12 });
  }

  // Observe any .lp-reveal elements not yet queued (data-lp-obs flag prevents double-observe)
  document.querySelectorAll('.lp-reveal:not([data-lp-obs])').forEach(function (el) {
    el.setAttribute('data-lp-obs', '');
    window.__lpReveal.observe(el);
  });
})();

// Re-observe newly rendered elements after Shopify theme editor reloads a section or block
['shopify:section:load', 'shopify:block:load'].forEach(function (evName) {
  document.addEventListener(evName, function () {
    if (!window.__lpReveal) return;
    document.querySelectorAll('.lp-reveal:not([data-lp-obs])').forEach(function (el) {
      el.setAttribute('data-lp-obs', '');
      window.__lpReveal.observe(el);
    });
  });
});
